// db.ts
import { openDB } from "idb";

const DATABASE_NAME = "AppDatabase";
const STORE_NAME = "Registros";
const FAVORITO_STORE_NAME = "favoritos"; 
export const initDB = async () => {
    const db = await openDB(DATABASE_NAME, 1, {
      upgrade(db) {
        // Object store para registros
        if (!db.objectStoreNames.contains(STORE_NAME)) {
          db.createObjectStore(STORE_NAME, { keyPath: "id", autoIncrement: true });
        }
  
        // Object store para favoritos
        if (!db.objectStoreNames.contains(FAVORITO_STORE_NAME)) {
          db.createObjectStore(FAVORITO_STORE_NAME, { keyPath: "id", autoIncrement: true });
        }
      },
    });
    return db;
  };

export const getAllRegistros = async () => {
  const db = await initDB();
  return await db.getAll(STORE_NAME);
};
export const returnDb = async () => {
  const db = await initDB();
  return db;
}
export const addRegistro = async (registro: any) => {
  const db = await initDB();
  return await db.add(STORE_NAME, registro);
};

export const deleteRegistro = async (id: number) => {
  const db = await initDB();
  return await db.delete(STORE_NAME, id);
};

export const getAllFavoritos = async (): Promise<any[]> => {
    const db = await initDB();
    const tx = db.transaction(FAVORITO_STORE_NAME, "readonly");
    const store = tx.objectStore(FAVORITO_STORE_NAME);
    const favoritos = await store.getAll();
    await tx.done;
    return favoritos;
  };
  
  
  // Função para adicionar um favorito no banco
  export const addFavorito = async (favorito: any) => {
    const db = await initDB();
    const tx = db.transaction(FAVORITO_STORE_NAME, "readwrite");
    const store = tx.objectStore(FAVORITO_STORE_NAME);
    await store.add(favorito);
    await tx.done;
  };
  
  export const deleteFavorito = async (id: number) => {
    const db = await initDB();
    const tx = db.transaction(FAVORITO_STORE_NAME, "readwrite");
    const store = tx.objectStore(FAVORITO_STORE_NAME);
    await store.delete(id);
    await tx.done;
  };
  